import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext.js';
import { identifyFreshchatUser, resetFreshchatUser, setAnonymousUser } from './freshchat.ts';

export const useFreshchat = () => {
  const { isSignedIn, email } = useAuth();

  useEffect(() => {
    if (isSignedIn && email) {
      // Identify the user in Freshchat when they're signed in
      identifyFreshchatUser({
        id: email, // Using email as the unique identifier
        email: email,
      });
    } else if (isSignedIn === false) {
      setAnonymousUser();
    }
  }, [isSignedIn, email]);

  // Function to explicitly reset user (for sign-out scenarios)
  const handleSignOut = () => {
    resetFreshchatUser();
  };

  return { handleSignOut };
}; 